module.exports = __webpack_public_path__ + "img/card_230590699.9df66efc.jpg";